
import Layout from '@/layout'

const epcRouter = {
  path: '/epc',
  component: Layout,
  name: 'searchParts',
  meta: {
    title: 'routeInfo',
    icon: 'frame16'

  },
  children: [
    // {
    //   path: 'search-vin',
    //   component: () => import('@/views/epc/searchVin'),
    //   name: 'SearchVin',
    //   meta: { title: 'VIN查询', icon: 'search-vin', code: 'epc:vin' }
    // },
    // {
    //   path: 'model-navigation',
    //   component: () => import('@/views/epc/modelNavigation'),
    //   name: 'Model',
    //   meta: { title: '车型导航', icon: 'tree-table', code: 'epc:nav' }
    // },

    {
      path: 'partsAdvice',
      component: () => import('@/views/epc/partsAdvice'),
      name: 'PartsAdvice',
      meta: { title: 'routePartsAdvice', icon: 'frame16', code: 'pac:management:page' }
    },
    {
      path: 'partsAdviceList',
      component: () => import('@/views/epc/partsAdviceList'),
      name: 'PartsAdviceList',
      meta: { title: 'routePartsAdviceList', icon: 'frame16', code: 'epc:consulting:page' },
      hidden: true
    },
    {
      path: 'partsAdviceResolvedList',
      component: () => import('@/views/epc/partsAdviceResolvedList'),
      name: 'PartsAdviceResolvedList',
      meta: { title: 'routeResolvedManagement', icon: 'frame16', code: 'epc:consulting:page' },
      hidden: true
    },
    {
      path: 'partAdviceInfo/:id',
      component: () => import('@/views/epc/partAdviceInfo'),
      name: 'PartAdviceInfo',
      meta: { title: 'routePartsAdviceDetails', icon: 'clipboard', noCache: true, activeMenu: '/views/epc/partAdviceInfo', code: 'pac:management:page' },
      hidden: true
    },
    {
      path: 'partAdviceAdminInfo/:id',
      component: () => import('@/views/epc/partAdviceAdminInfo'),
      name: 'PartAdviceAdminInfo',
      meta: { title: 'routePartsAdviceDetails', icon: 'clipboard', noCache: true, activeMenu: '/views/epc/partAdviceAdminInfo', code: 'epc:consulting:page' },
      hidden: true
    },
    {
      path: 'maintainFeedBack',
      component: () => import('@/views/epc/maintainFeedBack'),
      name: 'MaintainFeedBack',
      meta: { title: 'routeMaintainFeedBack', icon: 'frame29', code: 'pac:maintain:userpage' }
    },
    // {
    //   path: 'problemFeedBack',
    //   component: () => import('@/views/epc/problemFeedBack'),
    //   name: 'ProblemFeedBack',
    //   meta: { title: 'routeFeedBack', icon: 'frame17', code: 'epc:order' }
    // },
    {
      path: 'sysProFeedBack',
      component: () => import('@/views/epc/sysProFeedBack'),
      name: 'SysProFeedBack',
      meta: { title: 'routeSysProFeedBack', icon: 'frame17', code: 'epc:order' },
      hidden: true
    },
    {
      path: 'sysFeedBack',
      component: () => import('@/views/epc/sysFeedBack'),
      name: 'SysFeedBack',
      meta: { title: 'routeSysFeedBack', icon: 'frame17', code: 'pac:maintain:page' },
      hidden: true
    },
    {
      path: 'cart',
      component: () => import('@/views/epc/cart'),
      name: 'Cart',
      meta: { title: 'routeCart', icon: 'shopping', noCache: true, code: 'epc:cart' },
      hidden: true
    },
    {
      path: 'order',
      component: () => import('@/views/epc/order'),
      name: 'Order',
      meta: { title: 'routeOrder', icon: 'clipboard', noCache: true, code: 'epc:order:page' },
      hidden: true
    },
    {
      path: 'keyQuery',
      component: () => import('@/views/epc/keyQuery'),
      name: 'KeyQuery',
      meta: { title: 'routeKeyQuery', icon: 'shopping', noCache: true, code: 'epc:cart' },
      hidden: true
    },
    {
      path: 'iccId',
      component: () => import('@/views/epc/iccId'),
      name: 'IccId',
      meta: { title: 'routeIccId', icon: 'shopping', noCache: true, code: 'eis:iccid' },
      hidden: true
    },
    {
      path: 'queryStatistics',
      component: () => import('@/views/epc/queryStatistics'),
      name: 'QueryStatistics',
      meta: { title: 'routeQueryStatistics', icon: 'shopping', noCache: true, code: 'epc:cart' },
      hidden: true
    },
    // {
    //   path: '/generateOrder',
    //   component: () => import('@/views/epc/generateOrder'),
    //   name: 'generateOrder',
    //   meta: { title: '购物车清单', icon: 'clipboard' },
    //   hidden: true
    // },
    {
      path: '/orderDetail',
      component: () => import('@/views/epc/orderDetail'),
      name: 'orderDetail',
      meta: { title: '订单详情', icon: 'clipboard' },
      hidden: true
    }
  ]
}

export default epcRouter
